module.exports = __webpack_public_path__ + "img/mp_logo.6c4df6c0.png";